<template>
	<div>
		<div class="mt-4 container-fluid">
			<nav class="navbar navbar-expand-lg navbar-light">
			 	<h1 class="h3 mb-0 text-gray-800 mr-4 mb-2">
					Relatório - Categorias de Produtos
			  	</h1>
			  	<button 
					class="navbar-toggler" 
					type="button" 
					data-toggle="collapse" 
					data-target="#navbarSupportedContent" 
					aria-controls="navbarSupportedContent" 
					aria-expanded="false" 
					aria-label="Toggle navigation">
			    	<span class="navbar-toggler-icon"></span>
			  	</button>
			  	<div class="collapse navbar-collapse mt-4" id="navbarSupportedContent">
			  		<div class="form-row">
						<div class="form-group col-md-12">
							<input-date 
								time="1000"
								@date="setDate">
							</input-date>
						</div>
					</div>
			  	</div>
			</nav>
			<relatorio-categorias-totais 
				:key="categoriaTotaisKey"
				v-if="date"
				:date="date">
			</relatorio-categorias-totais>
			<relatorio-categorias-produtos-rank 
				:key="relatorioCategoriaRankKey"
				v-if="date"
				:date="date">
			</relatorio-categorias-produtos-rank>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				date: '',
				categoriaTotaisKey: 1,
				relatorioCategoriaRankKey: 2
			}
		},
		methods: {
			setDate(date){
				this.date = date;
				this.reload();
			},
			reload(){
				this.categoriaTotaisKey += 1;
				this.relatorioCategoriaRankKey += 1;
			}
		}
	}
</script>
